// extracted by mini-css-extract-plugin
export default {"wings":"wings_wings__y8LDp"};